var map = {
	"./bel9850.json": "7fHK",
	"./lekkerhot.json": "NnM5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "henr";


//////////////////
// WEBPACK FOOTER
// ./src/content ^\.\/.*\.json$
// module id = henr
// module chunks = 0